export const ORGANIZATION_PARAM = "org";
export const ITEM_UNAVAILABLE_MESSAGE = "This item is no longer available or isn't in your current organization.";
export const ITEM_LINK_RECOVERY_EVENT = "origin-item-link-recovery";

export function isUnavailableCanvasLink({ active, canvases = [], hasSelection, inventoriesReady, slug }) {
    return Boolean(active && inventoriesReady && hasSelection && !canvases.some((canvas) => canvas.slug === slug));
}

export function isUnavailableExplorerLink({ activeTab, currentMode, influenceTab, scopePath = [] }) {
    if (currentMode !== "explore") return false;
    return (activeTab?.kind === "influence" && !influenceTab)
        || (activeTab?.kind === "scope" && Boolean(activeTab.payload) && scopePath.length === 0);
}

export function isUnavailableStudioLink({ activeTab, canvases = [], currentMode, inventoriesReady, kernels = [], triggers = [], workflows = [] }) {
    if (currentMode !== "studio" || !inventoriesReady) return false;
    const payload = activeTab?.payload;
    switch (activeTab?.kind) {
        case "kernel": return !payload || !kernels.some((item) => item.command === payload);
        case "canvas": return !payload || !canvases.some((item) => item.slug === payload);
        case "workflow": return !payload || !workflows.some((item) => item.command === payload);
        case "trigger": return !payload || !triggers.some((item) => item.command === payload);
        default: return false;
    }
}

export function subscribeItemLinkRecovery(listener) {
    if (typeof window === "undefined") return () => {};
    window.addEventListener(ITEM_LINK_RECOVERY_EVENT, listener);
    return () => window.removeEventListener(ITEM_LINK_RECOVERY_EVENT, listener);
}

export function openCurrentOrganizationHome() {
    if (typeof window === "undefined") return;
    const current = new URLSearchParams(window.location.search);
    const organizations = current.getAll(ORGANIZATION_PARAM);
    const next = new URLSearchParams();
    if (organizations.length === 1 && organizations[0]) next.set(ORGANIZATION_PARAM, organizations[0]);
    window.dispatchEvent(new Event(ITEM_LINK_RECOVERY_EVENT));
    window.history.replaceState(null, "", `/${next.size ? `?${next}` : ""}`);
    window.dispatchEvent(new PopStateEvent("popstate", { state: null }));
}
